<template>
  <div class="list-handler"/>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      currentLine: null,
    };
  },
  props: [
    'editor',
  ],
  methods: {
    subscribe() {
      this.editor.subscribe('editableKeydown', this.detectList);
      this.editor.subscribe('editableKeyup', this.detectList);
    },
    unsubscribe() {
      this.editor.unsubscribe('editableKeydown', this.detectList);
      this.editor.unsubscribe('editableKeyup', this.detectList);
    },
    detectList(e) {
      this.currentLine = this.editor.getSelectedParentElement();
      const matchList = this.currentLine.innerHTML.match(/^(-&nbsp;).*/g);
      if (matchList && matchList.length > 0) {
        const content = this.currentLine.innerHTML.replace(/^(-&nbsp;)/g, '');
        this.currentLine.innerHTML = `<ul><li>${content}</li></ul>`;
      }
      const matchOlList = this.currentLine.innerHTML.match(/^(\d+.&nbsp;)/g);
      if (matchOlList && matchOlList.length > 0) {
        const content = this.currentLine.innerHTML.replace(/^(\d+.&nbsp;)/g, '');
        this.currentLine.innerHTML = `<ol><li>${content}</li></ol>`;
      }
    },
  },
  mounted() {
    this.subscribe();
  },
  destroyed() {
    this.unsubscribe();
  },
};
</script>
